import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularDraggableModule } from 'angular2-draggable';

import { BottombarMenusComponent } from './bottombar-menus.component';
import { BaseLayerModule } from './base-layer/base-layer.module';
import { LayerControlModule } from './layer-control/layer-control.module';
import { LegendModule } from './legend/legend.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    AngularDraggableModule,
    BaseLayerModule,
    LayerControlModule,
    LegendModule,
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // }),
  ],
  declarations: [BottombarMenusComponent],
  exports: [BottombarMenusComponent],
  bootstrap: [BottombarMenusComponent]
})
export class BottombarMenusModule { }
